import * as React from "react";
import { memo } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTimer = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 12 11",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M6 .18a.4.4 0 0 0-.4.4v1.738a.4.4 0 1 0 .8 0V.998a4.52 4.52 0 1 1-3.848 1.579.4.4 0 1 0-.61-.518A5.32 5.32 0 1 0 6 .18m-.608 5.785L3.38 3.158a.2.2 0 0 1 .279-.28l2.806 2.014a.768.768 0 1 1-1.072 1.073Z"
	})
});
const Memo = memo(SvgTimer);
export default Memo;
